import NoImage from "../../../../assets/images/utility/no_image.png";
import { DashboardLink } from "../../../../modules/merchandising/components/cells/ProductCell";
import TrellisLink from "../../../core/basic/TrellisLink";
import { css } from "../../../../../styled-system/css";
import { URL_PREFIX, APP_LINKS } from "../../../../modules/merchandising/constants";
import checkApplication from "../../../../utils/checkApplication";
import { useMemo } from "react";
import { useAppSelector } from "../../../../redux/hooks";
import { useTranslation } from "react-i18next";

interface MerchCategoryCellProps {
  value?: string;
  date?: string;
  original?: {
    category_id?: string;
  };
}

export const MerchCategoryCell = (props: MerchCategoryCellProps) => {
  const { t } = useTranslation(["merchandising"]);
  const user = useAppSelector((state) => state.user);
  const appLinks = useMemo(() => {
    return APP_LINKS.map((c) => ({
      ...c,
    })).filter((c) => checkApplication(user, c.app));
  }, [user]);
  const categoryId = props.original?.category_id;
  const image = `${URL_PREFIX}/api/productimage/?category=${categoryId}`;
  return (
    <div style={{ display: "flex" }}>
      <DashboardLink category={categoryId}>
        <div
          style={{
            userSelect: "none",
            WebkitUserSelect: "none",
            flexShrink: 0,
            width: 50,
            height: 50,
            marginRight: "10px",
            background: `url(${image}) no-repeat center / contain, url("${NoImage}") no-repeat center / contain`,
          }}
          draggable="false"
        />
      </DashboardLink>
      <div>
        <div>
          <DashboardLink category={categoryId}>{props.value}</DashboardLink>
        </div>
        <div>
          {appLinks
            .filter((c) => c.categoryLink)
            .map((appLink, i) => (
              <span key={appLink.id}>
                {i > 0 && (
                  <span key={i} style={{ color: "#ddd", marginRight: "5px" }}>
                    |
                  </span>
                )}
                <TrellisLink
                  key={appLink.id}
                  to={appLink.categoryLink!(categoryId!)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={css({
                    display: "inline-block",
                    marginRight: "xsmall",
                    color: "#888",
                    textDecoration: "none",
                    fontSize: "small",
                    fontWeight: "normal",
                    _hover: {
                      color: "var(--hover-color)",
                      fontWeight: "bold",
                    },
                  })}
                  style={
                    {
                      "--hover-color": appLink.color,
                    } as React.CSSProperties
                  }
                >
                  {t(appLink.name)}
                </TrellisLink>
              </span>
            ))}
        </div>
      </div>
    </div>
  );
};
